import React, { useState, useContext } from 'react';
import { Col, Container, Row, Button, Card, CardBody, CardHeader } from "reactstrap";
import { Link } from 'react-scroll';
import logoSoal from '../../../assets/images/game/w2_assets/Questionbar.png'
import Pilihan1 from '../../../assets/images/game/w2_soal/no-2/soal-2-left.png'
import Pilihan2 from '../../../assets/images/game/w2_soal/no-2/soal-2-right.png'
import { Context } from "../../../contexts/reducer/store";

import AnswerTrue from '../../../assets/images/game/w2_soal/no-2/soal no 2 benar _ salah.png'
import AnswerFalse from '../../../assets/images/game/w2_soal/no-2/soal no 2 benar _ salah.png'
import CheckAnswer from "../CheckAnswer";

import hiasan7 from '../../../assets/images/game/w2_assets/AdkBQM.png'
import hiasan9 from '../../../assets/images/game/w2_assets/AdkBQM-full.png'
import hiasan10 from '../../../assets/images/game/w2_assets/Asset-64.png'
import hiasan11 from '../../../assets/images/game/w2_assets/AdkBQM-2.png'
import Left from '../../../assets/images/game/w2_assets/question-title-left.png';
import Right from '../../../assets/images/game/w2_assets/question-title-right.png';

const Soal2 = () => {

    let [isOpen, setIsOpen] = useState(false)
    let [isTrue, setIsTrue] = useState(false)

    const [state, dispatch] = useContext(Context);
    const [disabled, setDisabled] = useState(false);

    function toggleModal ( type ) {
        setIsOpen(!isOpen);
        setIsTrue(type);
        setDisabled(true);
    }

    function SET_MARK ( value = Number ) {
        const init = {...state};
        let __mark = init.mark
        dispatch({type: 'SET_MARK', payload: __mark + value});
    }

    const Answer = () => {
        return (
            <>
                <div className={`${isTrue ? 'd-none' : 'd-block'} text-center`}>
                    <small>Berikut Penjelasan masing-masing pilihan jawaban :</small>
                </div>
                <img className="img-fluid" src={isTrue ? AnswerTrue : AnswerFalse} alt="" />
                <div className={`bg-light-green text-center py-1 ${isTrue ? 'd-none' : 'd-block'} my-3`}>
                    Jawaban yang benar pada soal adalah <b>Konten Yang Dimanipulasi.</b>
                </div>
            </>
        )
    }

    return (
        <>
            <Container className="front">
                <CheckAnswer Type={isTrue} isOpen={isOpen} setIsOpen={setIsOpen}>
                    <Answer />
                </CheckAnswer>
                <Row className="pb-5">
                    <Col md="12" className="text-center game-px position-relative">
                        <Row className="mb-5">
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Left} alt="" />
                            </Col>
                            <Col lg="10" md="10" sm="10" xs="10" className="my-auto">
                                <Card className="card-title-quiz">
                                    <CardBody>
                                        <h2 className="montserrat text-white">
                                            KONTEN YANG MENAMPILKAN <b>INFORMASI <br />ATAU GAMBAR ASLI KEMUDIAN <br />DIMANIPULASI UNTUK MENIPU</b><br /> TERMASUK DALAM JENIS HOAKS APA?
                                        </h2>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Right} alt="" />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md="12">
                                <Card className="card-game">
                                    <CardHeader className="bg-soal-pink text-center">
                                        <b>CONTOH KONTEN KLAIM HOAKS YANG DITANYAKAN</b>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col md="6" className="text-center q2-col">
                                                <span className="judul-pilihan-soal-2">KLAIM HOAKS</span>
                                                <div className="pt-4">
                                                    <img src={Pilihan1} alt="Klaim Hoaks" className="img-fluid w-50" />
                                                </div>
                                                <div className="pt-4">
                                                    <p className="desc-soal2 montserrat">
                                                        Menampilkan spanduk tempat Vaksin Covid-19 <br /> disertai teks berbahasa Inggris:
                                                        <br />
                                                        <b>“Don’t forget to donate your childrens organ.”</b> 
                                                        <br />
                                                        <br />
                                                        Atau dalam Bahasa Indonesia: <br />
                                                        <b>“Jangan lupa Mendonorkan Organ <br />
                                                        Anak-anak Anda”</b>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col md="6" className="text-center">
                                                <span className="judul-pilihan-soal-2">FAKTANYA</span>
                                                <div className="pt-4">
                                                    <img src={Pilihan2} alt="Klaim Hoaks" className="img-fluid w-50" />
                                                </div>
                                                <div className="pt-4">
                                                    <p className="desc-soal2 montserrat">
                                                        Memuat teks berbahasa Spanyol berbunyi:
                                                        <br />
                                                        <b>“Vacunas de Covid aquí. Sin cita previ.”</b> 
                                                        <br />
                                                        <br />
                                                        Atau dalam Bahasa Indonesia: <br />
                                                        <b>“Telah tersedia Vaksin Covid-19 dan tidak <br /> perlu membuat janji.”</b>
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            disabled === false
                            ? <Row>
                                    <Col md="6" className="text-center pt-3 p-0">
                                        <Link to="q3" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(true), SET_MARK(1))}>KONTEN YANG DIMANIPULASI</Link>
                                    </Col>
                                    <Col md="6" className="text-center pt-3 p-0">
                                        <Link to="q3" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>KONTEN TIRUAN</Link>
                                    </Col>
                                    <Col md="6" className="text-center pt-3 p-0">
                                        <Link to="q3" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>KONTEN PALSU</Link>
                                    </Col>
                                    <Col md="6" className="text-center pt-3 p-0">
                                        <Link to="q3" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>SATIRE/PARODI</Link>
                                    </Col>
                                </Row>
                            : <Row>
                                    <Col md="6" className="text-center pt-3 p-0">
                                        <button className="btn btn-jawaban montserrat" disabled>KONTEN YANG DIMANIPULASI</button>
                                    </Col>
                                    <Col md="6" className="text-center pt-3 p-0">
                                        <button className="btn btn-jawaban montserrat" disabled>KONTEN TIRUAN</button>
                                    </Col>
                                    <Col md="6" className="text-center pt-3 p-0">
                                        <button className="btn btn-jawaban montserrat" disabled>KONTEN PALSU</button>
                                    </Col>
                                    <Col md="6" className="text-center pt-3 p-0">
                                        <button className="btn btn-jawaban montserrat" disabled>SATIRE/PARODI</button>
                                    </Col>
                                </Row>
                        }
                    </Col>
                </Row>
            </Container>
            <div className="position-relative img-asset">
                <img src={hiasan10} alt="" className="asset-10" />
                <img src={hiasan11} alt="" className="asset-11" />
                <img src={hiasan9} alt="" className="asset-9" />
                <img src={hiasan7} alt="" className="asset-7" />
            </div>
        </>
    )
}

export default Soal2